import type { ReportOpenFailureReason } from '../../apiService';

export function reportOpenFailureMessage(
    reportTitle: string | undefined,
    reason: ReportOpenFailureReason,
): string {
    const subject = reportTitle?.trim() ? `“${reportTitle.trim()}”` : 'This report';

    switch (reason) {
        case 'not_found':
            return `${subject} is no longer available.`;
        case 'unauthorized':
            return `You do not have access to ${subject}. Contact your administrator.`;
        case 'server':
            return `${subject} could not be opened because the report service is unavailable. Try again.`;
        case 'malformed':
            return `${subject} could not be opened because the report data is incomplete. Contact support.`;
        case 'network':
            return `${subject} could not be opened because BARK could not reach the report service. Check your connection and try again.`;
        default: {
            const exhaustiveReason: never = reason;
            void exhaustiveReason;
            return `${subject} could not be opened. Try again.`;
        }
    }
}
